<template>
  <div>
      <v-card>
          <v-toolbar
              flat
              color="primary"
              dark
              dense
          >
              <v-icon left>mdi-account-key</v-icon>
                Roles
              <v-spacer />
              <v-btn
                  round
                  color="success"
                  :to="{name: 'OrgSelectedRoles', params: {id: 'new'}}"
              >
                  <v-icon left>add</v-icon>
                  New Role
              </v-btn>
          </v-toolbar>
          <v-card-text>
              <v-layout
                  row
                  wrap
              >
                  <v-flex
                      sm3
                      style="display:flex;flex-direction: column;"
                  >
                      <v-text-field
                        v-model="search"
                        box
                        hide-details
                        :loading="loading"
                        label="Search Roles"
                        clearable
                        style="flex-grow: 0;"
                      />
                      <v-list
                          three-line
                          style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                      >
                          <v-list-tile
                              v-for="role in roles"
                              :key="role.id"
                              :to="{name: 'OrgSelectedRoles', params: {id: role.id}}"
                          >
                              <v-list-tile-content>
                                  <v-list-tile-title v-html="role.name" />
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                      <v-card-actions>
                          <v-spacer />
                          <v-btn
                              :disabled="!canPrev"
                              icon
                              @click="goPage(-1)"
                          >
                              <
                          </v-btn>
                          &nbsp;
                          {{page * 10 - 9}}
                          -
                          {{page * 10 > total ? total : page * 10}}
                           of 
                          {{total}}
                          &nbsp;
                          <v-btn
                              :disabled="!canNext"
                              icon
                              @click="goPage(1)"
                          >
                              >
                          </v-btn>
                          <v-spacer />
                      </v-card-actions>
                  </v-flex>
                  <v-flex
                      sm9
                  >
                      <v-card
                          v-if="focusRole || loadingRole"  
                          style="margin: 0 10px 0 10px;"
                      >
                          <v-toolbar
                              dense
                              flat
                          >
                              Role Permissions Editor
                              <v-spacer />
                              <v-btn
                                  small
                                  @click="$router.replace({name: 'OrgRoles'})"
                              >
                                  Cancel
                              </v-btn>
                              <v-btn
                                  :disabled="!changed || saving"
                                  color="primary"
                                  small
                                  @click="saveRole()"
                              >
                                  Save Changes
                              </v-btn>
                          </v-toolbar>

                          <v-card-text
                              v-show="loadingRole"
                          >
                              <div
                                  style="padding: 25px;margin:auto"
                              >
                                  <v-progress-linear
                                      indeterminate
                                      query
                                  />
                              </div>
                          </v-card-text>
                          <v-card-text
                              v-show="!loadingRole"
                          >
                              <v-text-field
                                v-model="focusRole.name"
                                label="Name"
                              />
                              <br /><br />
                              
                              <div
                                class="perm-div"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Templates
                                </div>
                                <v-radio-group
                                  v-model="focusRole.templates"
                                  row
                                  persistent-hint
                                  hint="Controls access to modifying and creating form templates"
                                >
                                  <v-radio label="No Access" on-icon="mdi-eye-off-outline" off-icon="mdi-eye-off-outline" :value="PERMISSIONS.NO_ACCESS"></v-radio>
                                  <v-radio label="Full Access" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Organization News
                                </div>
                                <v-radio-group
                                  v-model="focusRole.org_manage_news"
                                  row
                                  persistent-hint
                                  hint="Controls whether a user can create and manage news for your organization"
                                >
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Contacts
                                </div>
                                <v-radio-group
                                  v-model="focusRole.contacts"
                                  row
                                  persistent-hint
                                  hint="Controls access to modifying and creating contacts"
                                >
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Edit" on-icon="mdi-pencil-circle" off-icon="mdi-pencil-circle" :value="PERMISSIONS.CAN_EDIT"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                  <v-radio label="Bulk" on-icon="mdi-plus-circle-multiple" off-icon="mdi-plus-circle-multiple" :value="PERMISSIONS.CAN_BULK"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div perm-sub"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Contact Messages
                                </div>
                                <v-radio-group
                                  v-model="focusRole.contacts_messages"
                                  row
                                  persistent-hint
                                  hint="Controls access to viewing and sending contact messages"
                                >
                                  <v-radio label="No Access" on-icon="mdi-eye-off-outline" off-icon="mdi-eye-off-outline" :value="PERMISSIONS.NO_ACCESS"></v-radio>
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                  <v-radio label="Bulk" on-icon="mdi-plus-circle-multiple" off-icon="mdi-plus-circle-multiple" :value="PERMISSIONS.CAN_BULK"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div perm-sub"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Contact Messages Read
                                </div>
                                <v-radio-group
                                  v-model="focusRole.contacts_messages_read"
                                  row
                                  persistent-hint
                                  hint="Controls whether a user can mark a message as read"
                                >
                                  <v-radio label="No Access" on-icon="mdi-eye-off-outline" off-icon="mdi-eye-off-outline" :value="PERMISSIONS.NO_ACCESS"></v-radio>
                                  <v-radio label="Edit" on-icon="mdi-pencil-circle" off-icon="mdi-pencil-circle" :value="PERMISSIONS.CAN_EDIT"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div perm-sub"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Contact Files
                                </div>
                                <v-radio-group
                                  v-model="focusRole.contacts_files"
                                  row
                                  persistent-hint
                                  hint="Controls access to viewing and sending contact files"
                                >
                                  <v-radio label="No Access" on-icon="mdi-eye-off-outline" off-icon="mdi-eye-off-outline" :value="PERMISSIONS.NO_ACCESS"></v-radio>
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                  <v-radio label="Delete" on-icon="mdi-delete-circle" off-icon="mdi-delete-circle" :value="PERMISSIONS.CAN_DELETE"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div perm-sub"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Contact Files Read
                                </div>
                                <v-radio-group
                                  v-model="focusRole.contacts_files_read"
                                  row
                                  persistent-hint
                                  hint="Controls whether a user can mark a file as read"
                                >
                                  <v-radio label="No Access" on-icon="mdi-eye-off-outline" off-icon="mdi-eye-off-outline" :value="PERMISSIONS.NO_ACCESS"></v-radio>
                                  <v-radio label="Edit" on-icon="mdi-pencil-circle" off-icon="mdi-pencil-circle" :value="PERMISSIONS.CAN_EDIT"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Cases
                                </div>
                                <v-radio-group
                                  v-model="focusRole.cases"
                                  row
                                  persistent-hint
                                  hint="Controls access to modifying and creating cases"
                                >
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Edit" on-icon="mdi-pencil-circle" off-icon="mdi-pencil-circle" :value="PERMISSIONS.CAN_EDIT"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                  <v-radio label="Bulk" on-icon="mdi-plus-circle-multiple" off-icon="mdi-plus-circle-multiple" :value="PERMISSIONS.CAN_BULK"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Case News
                                </div>
                                <v-radio-group
                                  v-model="focusRole.case_manage_news"
                                  row
                                  persistent-hint
                                  hint="Controls whether a user can create and manage news for a case"
                                >
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Forms
                                </div>
                                <v-radio-group
                                  v-model="focusRole.userform"
                                  row
                                  persistent-hint
                                  hint="Controls access to modifying and creating forms; (Contact means the user is limited to editing only what a Contact can edit)"
                                >
                                  <v-radio label="View" on-icon="mdi-eye" off-icon="mdi-eye" :value="PERMISSIONS.CAN_VIEW"></v-radio>
                                  <v-radio label="Contact" on-icon="mdi-account-box" off-icon="mdi-account-box" :value="PERMISSIONS.CAN_CONTACT_EDIT"></v-radio>
                                  <v-radio label="Edit" on-icon="mdi-pencil-circle" off-icon="mdi-pencil-circle" :value="PERMISSIONS.CAN_EDIT"></v-radio>
                                  <v-radio label="Create" on-icon="mdi-plus-circle" off-icon="mdi-plus-circle" :value="PERMISSIONS.CAN_CREATE"></v-radio>
                                  <v-radio label="Bulk" on-icon="mdi-plus-circle-multiple" off-icon="mdi-plus-circle-multiple" :value="PERMISSIONS.CAN_BULK"></v-radio>
                                </v-radio-group>
                              </div>
                              
                              <div
                                class="perm-div perm-sub"
                                style="padding: 10px;"
                              >
                                <div
                                  class="perm-title"
                                  style="font-size: 16px;"
                                >
                                  Form Answer Review
                                </div>
                                <v-radio-group
                                  v-model="focusRole.userform_answer_review"
                                  row
                                  persistent-hint
                                  hint="Controls access to viewing and creating answer reviews"
                                >
                                  <v-radio label="No Access" on-icon="mdi-eye-off-outline" off-icon="mdi-eye-off-outline" :value="PERMISSIONS.NO_ACCESS"></v-radio>
                                  <v-radio label="Edit" on-icon="mdi-pencil-circle" off-icon="mdi-pencil-circle" :value="PERMISSIONS.CAN_EDIT"></v-radio>
                                </v-radio-group>
                              </div>
                          </v-card-text>
                      </v-card>
                      <div
                        v-else
                        style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                      >
                        <div
                          style="text-align:center;font-size: 20px;font-weight: 300;"
                        >
                          <b>Select a Role to edit or create a new Role.</b><br />
                          <small>Set a User's Role in the Users tab</small>
                        </div>
                        <div
                          style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                        >
                          <v-icon
                            left
                            size="32"
                            style="align-self: flex-start;"
                          >
                            mdi-information
                          </v-icon>
                          <div>
                            <div
                              style="font-size: 16px;font-weight: 700;"
                            >
                              About Roles
                            </div>
                            <div
                              style="font-size: 12px;"
                            >
                              Roles limit the actions a user can perform. You can limit users ability to perform bulk actions, or restrict them to viewing only.<br /><br />You can also limit access to Contact Files, Messages and Answer Reviews.
                            </div>
                          </div>
                        </div>
                      </div>
                  </v-flex>
              </v-layout>
          </v-card-text>
      </v-card>
  </div>
</template>
  

<script>
import api from '@/api'
import GlobalConstants from '@/globals'
import Draggable from 'vuedraggable'
import OptionListBuilder from '@/components/admin/formtemplate/OptionListBuilder'
import SubFieldType from '@/components/admin/formtemplate/SubFieldType'
import { mapActions } from 'vuex'

export default {
    components: {
        Draggable,
        OptionListBuilder,
        SubFieldType
    },
    data () {
        return {
            roles: null,
            focusRole: null,
            changed: false,
            loading: false,
            loadingRole: false,
            saving: false,
            search: null,
            page: 1,
            canNext: false,
            canPrev: false,
            total: 0,
        }
    },
    created () {
        if (this.$route.params.id) {
            this.getRole(this.$route.params.id)
        }
        this.getRoles()
        this.documentTitle('Roles')
    },
    methods: {
        goPage (int) {
            if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                this.page = this.page + int
                this.getRoles(this.search)
            }
        },
        getRoles (search = null) {
            this.loading = true
            api.users.roles.list({
              search: search, 
              pageNum: this.page
            })
                .then((data) => {
                    this.total = data['count']
                    this.canNext = data['next_page'] !== null
                    this.canPrev = data['previous_page'] !== null
                    this.roles = data['results']
                    this.loading = false
                })
        },
        getRole (id) {
            this.loadingRole = true
            api.users.roles.get(id)
                .then((data) => {
                    this.focusRole = data
                    this.changed = false
                })
        },
        saveRole () { 
          this.changed = false
          api.users.roles.save(this.focusRole)
          .then((data) => {
            if ('id' in this.focusRole) {
              this.focusRole = data
            } else {
              this.roles.push(data)
              this.$router.replace({name: 'OrgSelectedRoles', params: {id: data.id}})
            }
          })
          .finally(() => {
            this.changed = false
            this.getRoles(this.search)
            this.$forceUpdate()
          })
        }
    },
    async beforeRouteUpdate(to, from, next) {
        if (this.changed) {
            const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
            if (!answer)
                return false
        }
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (this.changed) {
            const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
            if (!answer)
                return false
        }
        next()
    },
    watch: {   
        $route (to, from) {
            if (to.params.id == "new") {
              this.loadingRole = true
              this.focusRole = {
                name: 'A New Role'
              }
              this.changed = false
              this.loadingRole = false
            }
            else if (to.params.id) {
                this.getRole(to.params.id)
            } 
            else {
                this.focusRole = null
            } 
        },
        search () {
            this.page = 1
            this.getRoles(this.search)
        },
        focusRole: {
            handler(newValue, oldValue) {
                if (this.loadingRole || !this.$route.params.id) {
                    this.changed = false
                    this.loadingRole = false
                }
                else
                    this.changed = true
            },
            deep: true,
            flush: 'post'
        }
    }
}
</script>
  
  <style>
  
  .disabled-user {
    background: #FFCDD2;
  }
  
  .search-bar {
    margin-top: 1em;
  }
  
  table {
    margin-top: 1em;
  }

  .perm-div .v-input {
    margin-top: unset;
  }

  .perm-div .v-radio {
    padding: 10px;
    border-radius: 25px;
    margin-right: unset;
    transition: background 0.3s ease-in-out;
    background: rgba(0,0,0,0.01);
    border: 1px solid rgba(0,0,0,0.1);
  }
  
  .perm-div .v-input__slot {
    border-radius: 25px;
    background: rgba(26,26,26,0.05);
    padding: 5px;
  }

  .perm-div .v-input--selection-controls__input {
  }

  .perm-div .v-radio.accent--text {
    background: #1976d2 !important;
  }

  .perm-div .v-radio.accent--text .v-label {
    color: white !important;
  }

  .perm-div .v-radio.accent--text .v-icon {
    color: white !important;
  }

  .perm-div .v-radio .v-label {
    transition: color 0.3s ease-in-out;
  }

  .perm-div .v-radio .v-icon {
    transition: color 0.3s ease-in-out;
  }

  .perm-div .v-input--radio-group__input {
	  justify-content: space-between;
  }

  .perm-sub {
    position:relative;
  }
  </style>
  